/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
/* eslint-disable dot-notation */
import QueryString from 'query-string'

import history from 'routes/history'

import { EVENT_TYPE } from 'resources'

import { sendAnalyticsEvent } from 'services/analytics'

import * as api from './api'

const DEBUG = process.env.NODE_ENV === 'development'

// https://help.branch.io/developers-hub/docs/in-app-routing#branch-added-parameters
// Note: This does not remove all branch added params, but covers most of them.
// Ex: utm_* will still be passed along
const BRANCH_PARAMS_PREFIXES = [
  '~', // Branch analytics
  '+', // Branch-Added information
  '$', // Branch internal controls
]

export const initBranch = async () => {
  const branchEvent = await api.initBranch(process.env.REACT_APP_BRANCH_API_KEY)
  DEBUG && console.log('[Branch] Received Event:', branchEvent)
  const { data_parsed: branchParsedEvent } = branchEvent
  const isBranchLink = !!(branchParsedEvent || {})['+clicked_branch_link']
  if (isBranchLink) {
    const desktopDeepLinkPath = branchParsedEvent['$desktop_deeplink_path']
    const defaultDeepLinkPath = branchParsedEvent['$deeplink_path']
    const deepLinkPath = `/${desktopDeepLinkPath || defaultDeepLinkPath}`

    // Combine $deepLinkPath set and query params added to the Branch Link externally
    const linkAddedQueryParams = Object.entries(branchParsedEvent).reduce((acc, [key, value]) => {
      if (BRANCH_PARAMS_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        return acc
      }
      return { ...acc, [key]: value }
    }, {})
    const { url, query: branchLinkQueryParams } = QueryString.parseUrl(deepLinkPath)
    const combinedDeepLinkPath = QueryString.stringifyUrl({
      url,
      query: {
        ...branchLinkQueryParams,
        ...linkAddedQueryParams,
      },
    })

    DEBUG && console.log('[Branch] Redirecting to:', combinedDeepLinkPath)
    sendAnalyticsEvent(EVENT_TYPE.branchDeepLinkOpen, {
      branchEvent: branchParsedEvent,
      branchLinkQueryParams: desktopDeepLinkPath || defaultDeepLinkPath,
      linkAddedQueryParams,
      finalDeepLink: combinedDeepLinkPath,
    })
    history.replace(combinedDeepLinkPath)
  }
}

export * from './branchService'
